export default "__VITE_ASSET__CgF0R9No__"